const ROUTE_VIEW_USER = [
  // 我的
  { path: '/user/card', name: '电子社保卡', h5Uri: '/user/user_card', nativeUri: null, whiteList: true },
  { path: '/user/following', name: '我的关注', h5Uri: '/user/user_following', nativeUri: null, whiteList: false },
  { path: '/user/collection', name: '我的收藏', h5Uri: '/user/user_collection', nativeUri: null, whiteList: false },
  { path: '/user/memberMsg', name: '已绑定医院', h5Uri: '/user/member_msg', nativeUri: null, whiteList: false },
  { path: '/user/pay', name: '我的缴费', h5Uri: '/user/user_pay', nativeUri: null, whiteList: false },
  { path: '/user/electronicHealthCode', name: '电子健康码', h5Uri: '/user/user_ElectronicHealthCode', nativeUri: null, whiteList: false },
  { path: '/user/comment', name: '就医反馈', h5Uri: '/user/register_comment', nativeUri: null, whiteList: false },
  { path: '/user/commentContent', name: '评价', h5Uri: '/user/comment_content', nativeUri: null, whiteList: false },
  // 我的就诊人
  { path: '/user/member', name: '我的家庭就诊人', h5Uri: '/user/user_member', nativeUri: null, whiteList: false },
  { path: '/user/mypatient/myPatient', name: '我的就诊人', h5Uri: '/user/mypatient/myPatient', nativeUri: null, whiteList: false },
  // { path: '/user/mypatient/hospital_Information', name: '住院号信息', h5Uri: '/user/mypatient/hospital_Information', nativeUri: null },
  { path: '/user/mypatient/add_number', name: '添加住院号', h5Uri: '/user/mypatient/add_number', nativeUri: null, whiteList: false },
  { path: '/user/mypatient/inpatient_list', name: '住院号列表', h5Uri: '/user/mypatient/number_list', nativeUri: null, whiteList: false }
]

export default ROUTE_VIEW_USER



// WEBPACK FOOTER //
// ./src/router/mapping/user.js